"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LineLayout_1 = require("./line/LineLayout");
/**
 * Distributes items over layout lines.
 */
class LineLayouter {
    constructor(_layout) {
        this._layout = _layout;
        this.mainAxisContentSize = 0;
        this.curMainAxisPos = 0;
        this.mainAxisSize = 0;
        this.maxMainAxisPos = 0;
    }
    layoutLines() {
        this.setup();
        const items = this._layout.items;
        const wrap = this._layout.isWrapping();
        let startIndex = 0;
        let i;
        const n = items.length;
        for (i = 0; i < n; i++) {
            const item = items[i];
            this.layoutFlexItem(item);
            // Get predicted main axis size.
            const itemMainAxisSize = item.flexItem.getMainAxisLayoutSizeWithPaddingAndMargin();
            if (wrap && i > startIndex) {
                const isOverflowing = this.curMainAxisPos + itemMainAxisSize > this.mainAxisSize;
                if (isOverflowing) {
                    this.layoutLine(startIndex, i - 1);
                    this.curMainAxisPos = 0;
                    startIndex = i;
                }
            }
            this.addToMainAxisPos(itemMainAxisSize);
        }
        if (startIndex < i) {
            this.layoutLine(startIndex, i - 1);
        }
    }
    setup() {
        this.mainAxisSize = this._layout.mainAxisSize;
        this.curMainAxisPos = 0;
        this.maxMainAxisPos = 0;
        this.lines = [];
        this.mainAxisMinSize = undefined;
        this.crossAxisMinSize = undefined;
        this.mainAxisContentSize = 0;
    }
    layoutFlexItem(item) {
        if (item.isFlexEnabled()) {
            item.flexLayout.updateTreeLayout();
        }
        else {
            item.flexItem.resetLayoutSize();
        }
    }
    addToMainAxisPos(itemMainAxisSize) {
        this.curMainAxisPos += itemMainAxisSize;
        if (this.curMainAxisPos > this.maxMainAxisPos) {
            this.maxMainAxisPos = this.curMainAxisPos;
        }
    }
    layoutLine(startIndex, endIndex) {
        const availableSpace = this.getAvailableMainAxisLayoutSpace();
        const line = new LineLayout_1.LineLayout(this._layout, startIndex, endIndex, availableSpace);
        line.performLayout();
        this.lines.push(line);
        if (this.mainAxisContentSize === 0 || this.curMainAxisPos > this.mainAxisContentSize) {
            this.mainAxisContentSize = this.curMainAxisPos;
        }
    }
    getAvailableMainAxisLayoutSpace() {
        if (!this._layout.isResizingMainAxis() && this._layout.isMainAxisFitToContents()) {
            return 0;
        }
        else {
            return this.mainAxisSize - this.curMainAxisPos;
        }
    }
    calcCrossAxisMinSize() {
        let crossAxisMinSize = 0;
        const items = this._layout.items;
        for (let i = 0, n = items.length; i < n; i++) {
            const item = items[i];
            const itemCrossAxisMinSize = item.flexItem.getCrossAxisMinSizeWithPaddingAndMargin();
            crossAxisMinSize = Math.max(crossAxisMinSize, itemCrossAxisMinSize);
        }
        return crossAxisMinSize;
    }
    calcMainAxisMinSize() {
        const lines = this.lines;
        if (lines.length === 1) {
            return lines[0].getMainAxisMinSize();
        }
        else {
            // Wrapping lines: specified width is used as min width (in accordance to W3C flexbox).
            return this._layout.mainAxisSize;
        }
    }
    getLines() {
        return this.lines;
    }
    getMainAxisMinSize() {
        if (this.mainAxisMinSize === undefined) {
            this.mainAxisMinSize = this.calcMainAxisMinSize();
        }
        return this.mainAxisMinSize;
    }
    getCrossAxisMinSize() {
        if (this.crossAxisMinSize === undefined) {
            this.crossAxisMinSize = this.calcCrossAxisMinSize();
        }
        return this.crossAxisMinSize;
    }
    getMainAxisContentSize() {
        return this.mainAxisContentSize;
    }
}
exports.LineLayouter = LineLayouter;
//# sourceMappingURL=LineLayouter.js.map